// extracted by mini-css-extract-plugin
export default {"modal":"ReportAdModal-module__modal___tF9EK"};